import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  loading: false,
  registrationSuccess: false,
  temporaryBookingDataFromLanding: null,
  completeRegistration:false,
  error: null,
}

const slice = createSlice({
  name: 'registration',
  initialState: initialState,
  reducers: {
    registrationCustomerAction: (state, action) => {
      state.loading = true
      state.error = null
    },
    registrationCustomerSuccessAction:(state,)=>{
      state.loading = true
      state.error = null
      state.registrationSuccess = true
    },
    registrationCustomerErrorAction: (state, action) => {
      state.loading = false
      state.registrationSuccess = false
      state.error = action.payload
    },
    setTemporaryBookingDataFromLandingAction: (state, action) => {
      state.temporaryBookingDataFromLanding = action.payload;
    },
    completeRegistrationAction: (state, action) => {
      state.loading = true
      state.error = null
      state.completeRegistration = false
    },
    completeRegistrationSuccessAction:(state,)=>{
      state.loading = true
      state.error = null
      state.completeRegistration = true
    },
    completeRegistrationErrorAction: (state, action) => {
      state.loading = false
      state.completeRegistration = false
      state.error = action.payload
    },
    registrationPartialResetState: (state) => {
      state.loading = false
      state.registrationSuccess = false
      state.error = null
      state.completeRegistration = false
    },
    registrationResetState: () => initialState,
  },
});

export const {
  registrationCustomerAction,
  registrationCustomerSuccessAction,
  registrationCustomerErrorAction,
  setTemporaryBookingDataFromLandingAction,
  completeRegistrationAction,
  completeRegistrationSuccessAction,
  completeRegistrationErrorAction,
  registrationPartialResetState,
  registrationResetState,
} = slice.actions

export default slice.reducer
